// extracted by mini-css-extract-plugin
export var cardHeader = "_rn-0";
export var reorderHandle = "_rn-3";
export var titleArea = "_rn-1";
export var titleAreaWithHandle = "_rn-2";